import {Interventions} from './Interventions';
export default Interventions;
